var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-details d-md-flex flex-row",class:_vm.containerMargin},[_vm._t("default",function(){return [(_vm.label)?_c('div',{staticClass:"text-primary mr-3",class:_vm.labelClass},[_vm._v(_vm._s(_vm.label)+":")]):_vm._e()]}),_c('div',{staticClass:"align-items-center contact-detail-value"},[_vm._v(_vm._s(_vm.value))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }